// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1gYHa","title":"FrontImage_title__3vvyE"};